/**
 * 공통 아이콘
 */
export const commonImage = {
  logoUaeAzizi: '/assets/icon/logo/icon-logo-uae-azizi.png',
  logoUaeAziziSvg: '/assets/icon/logo/icon-logo-uae-azizi.svg',
  logo4s: '/assets/icon/logo/icon-logo-4s.svg',
  logo4sBlack: '/assets/icon/logo/icon-logo-4s-black.svg',
  logoSamsung: '/assets/icon/logo/icon-logo-samsung-v2.svg',
  logoSamsungV2: '/assets/icon/logo/icon-logo-samsung-v2.svg',
  logoSamsungWhite: '/assets/icon/logo/icon-logo-samsung-white.svg',
  logoGsil: '/assets/icon/logo/icon-logo-gsil.svg',
  logoGsilWhite: '/assets/icon/logo/icon-logo-gsil-white.svg',
  logoSafetyWhite: '/assets/icon/logo/icon-logo-safety100-white.svg',
  calender: '/assets/icon/icon-calender.svg',
  laguage: '/assets/icon/icon-laguage.svg',
  logout: '/assets/icon/icon-logout.svg',
  mypage: '/assets/icon/icon-mypage.svg',
  modalClose: '/assets/icon/icon-close.svg',
  carouselStop: '/assets/icon/icon-stop.svg',
  carouselPlay: '/assets/icon/icon-play.svg',
  search: '/assets/icon/icon-search.svg',
  searchWhite: '/assets/icon/icon-search-white.svg',
  cancel: '/assets/icon/icon-cancel.svg',
  camera: '/assets/icon/icon-camera.svg',
  cctv: '/assets/icon/icon-cctv.svg',
  delete: '/assets/icon/icon-delete.svg',
  file: '/assets/icon/icon-file.svg',
  fileUploadOff: '/assets/icon/icon-upload-file.svg',
  fileUploadOn: '/assets/icon/icon-upload-file-on.svg',
  alarm: '/assets/icon/icon-alarm.svg',
  alarmNormal: '/assets/icon/icon-alarm-normal.svg',
  alarmUnread: '/assets/icon/icon-alarm-unread.svg',
  fileDownload: '/assets/icon/icon-file-download.svg',
  dummyV1: '/assets/image/image_dummy_1.jpg',
  download: '/assets/icon/icon-download.svg',
  gsMapDummy: '/assets/image/image_gs_dashboard_dummy.png',
  gsHeader: '/assets/image/chart/image-gs-header.svg',
  gsBorder: '/assets/image/chart/image-chart-border.svg',
  gsCardBorder: '/assets/image/chart/image-chart-card-border.svg'
};

/**
 * 국가 아이콘
 */
export const nationIcon = {
  kor: '/assets/icon/nation/kor.svg',
  sau: '/assets/icon/nation/sau.svg',
  uae: '/assets/icon/nation/uae.svg'
};

/**
 * 메뉴 아이콘
 */
export const menuImage = {
  menuClose: '/assets/icon/menu/icon-menu-close.svg',
  menuOpen: '/assets/icon/menu/icon-menu-open.svg',
  dashboard: '/assets/icon/menu/icon-menu-dashboard.svg',
  notice: '/assets/icon/menu/icon-menu-notice.svg',
  pjt: '/assets/icon/menu/icon-menu-pjt.svg',
  company: '/assets/icon/menu/icon-menu-company.svg',
  user: '/assets/icon/menu/icon-menu-user.svg',
  passport: '/assets/icon/menu/icon-menu-passport.svg',
  ptw: '/assets/icon/menu/icon-menu-ptw.svg',
  tbm: '/assets/icon/menu/icon-menu-tbm.svg',
  weather: '/assets/icon/menu/icon-menu-weather.svg',
  cctv: '/assets/icon/menu/icon-menu-cctv.svg',
  system: '/assets/icon/menu/icon-menu-system.svg'
};

/**
 * 화살표 아이콘
 */
export const arrowImage = {
  arrowCircle: '/assets/icon/arrow/icon-arrow-circle.svg',
  arrowDropDown: '/assets/icon/arrow/icon-arrow-dropdown.svg',
  arrowNext: '/assets/icon/arrow/icon-arrow-next.svg',
  arrowNextPrimary: '/assets/icon/arrow/icon-arrow-next-primary.svg',
  arrowPrev: '/assets/icon/arrow/icon-arrow-prev.svg',
  arrowTriangle: '/assets/icon/arrow/icon-arrow-triangle.svg',
  arrowTriangleWhite: '/assets/icon/arrow/icon-arrow-triangle-white.svg'
};

/**
 * 체크박스 아이콘
 */
export const checkboxImage = {
  checkboxOff: '/assets/icon/checkbox/icon-checkbox-off.svg',
  checkboxOn: '/assets/icon/checkbox/icon-checkbox-on.svg',
  selectBox: '/assets/image/image_select.png'
};

/**
 * 체크박스 아이콘
 */
export const fileImage = {
  avi: '/assets/icon/file/icon-avi.svg',
  css: '/assets/icon/file/icon-css.svg',
  doc: '/assets/icon/file/icon-doc.svg',
  eps: '/assets/icon/file/icon-eps.svg',
  jpg: '/assets/icon/file/icon-jpg.svg',
  jpeg: '/assets/icon/file/icon-jpg.svg',
  mp3: '/assets/icon/file/icon-mp3.svg',
  pdf: '/assets/icon/file/icon-pdf.svg',
  png: '/assets/icon/file/icon-png.svg',
  psd: '/assets/icon/file/icon-psd.svg',
  txt: '/assets/icon/file/icon-txt.svg',
  xls: '/assets/icon/file/icon-xls.svg',
  zip: '/assets/icon/file/icon-zip.svg',
  pptx: '/assets/icon/file/icon-pptx.svg',
  etc: '/assets/icon/file/icon-etc.svg'
};

/**
 * 라디오 버튼 아이콘
 */
export const radioImage = {
  radioOff: '/assets/icon/radio/icon-radio-off.svg',
  radioOn: '/assets/icon/radio/icon-radio-on.svg'
};

/**
 * 상태값 별 아이콘
 */
export const statusImage = {
  circleCheck: '/assets/icon/status/icon-circle-check.svg',
  circleError: '/assets/icon/status/icon-circle-error.svg',
  editSquare: '/assets/icon/status/icon-edit-square.svg',
  editSquareActive: '/assets/icon/status/icon-edit-square-active.svg',
  hidden: '/assets/icon/status/icon-hidden.svg',
  refresh: '/assets/icon/status/icon-refresh.svg',
  trashDelete: '/assets/icon/status/icon-trash-delete.svg',
  deleteActive: '/assets/icon/status/icon-delete-active.svg',
  visibility: '/assets/icon/status/icon-visibility.svg',
  add: '/assets/icon/status/icon-add.svg',
  download: '/assets/icon/status/icon-download.svg',
  addBlack: '/assets/icon/status/icon-add-black.svg'
};

/**
 * 로그인 이미지
 */
export const loginImage = {
  image1: '/assets/image/login/main1.webp',
  image2: '/assets/image/login/main2.webp',
  image3: '/assets/image/login/main3.webp',
  inquiry: '/assets/image/login/image-login-inquiry.png',
  invitation: '/assets/image/login/image-login-invitation.png'
};

export const approvalImage = {
  denied: '/assets/image/denied.png'
};

export const ciImage = {
  adnocLogo: '/assets/image/ci/adnoc-logo.svg',
  atlantisLogoNormal: '/assets/image/ci/atlantis-logo-normal.svg',
  atlantisLogoWhite: '/assets/image/ci/atlantis-logo-white.svg',
  emaarLogoNormal: '/assets/image/ci/emaar-logo-normal.png',
  emaarLogoWhite: '/assets/image/ci/emaar-logo-white.png',
  gsilLogoNormal: '/assets/image/ci/gsil-logo-normal.svg',
  gsilLogoPointcolor: '/assets/image/ci/gsil-logo-pointcolor.svg',
  gsilLogoWhite: '/assets/image/ci/gsil-logo-white.svg',
  logo4s: '/assets/image/ci/logo-4s.svg',
  logoSamsungWhite: '/assets/image/ci/logo-samsung-white.svg',
  logoGsWhite: '/assets/image/ci/logo-gsca-white.svg'
};

/**
 * 환경 이미지
 * @type {{rain, common, temperature, humidity, barometer, windDirection, setting, wind, humidity2, wind2, rain2}}
 */
export const environmentIcon = {
  common: '/assets/image/environment/common.svg',
  humidity: '/assets/image/environment/humidity.svg',
  barometer: '/assets/image/environment/barometer.svg',
  rain: '/assets/image/environment/rain.svg',
  setting: '/assets/image/environment/setting.svg',
  temperature: '/assets/image/environment/temparature.svg',
  wind: '/assets/image/environment/wind.svg',
  windDirection: '/assets/image/environment/wind_direction.svg',
  humidity2: '/assets/icon/weather/icon-humidity.svg',
  wind2: '/assets/icon/weather/icon-wind.svg',
  rain2: '/assets/icon/weather/icon-umbrella.svg'
};

export const chartDashboardImage = {
  clock: '/assets/image/chart/clock.png',
  cloudy: '/assets/image/chart/cloudy.png',
  company: '/assets/image/chart/company.png',
  huma: '/assets/image/chart/huma.png',
  iconNext: '/assets/image/chart/icon-next.png',
  iconNextSvg: '/assets/image/chart/icon-next.svg',
  iconPrev: '/assets/image/chart/icon-prev.png',
  iconPrevSvg: '/assets/image/chart/icon-prev.svg',
  iconAlarm: '/assets/image/chart/icon__alarm.svg',
  iconLogout: '/assets/image/chart/icon_logout.svg',
  iconMenuOpen: '/assets/image/chart/icon_menu-open.svg',
  iconMypage: '/assets/image/chart/icon_mypage.svg',
  index: '/assets/image/chart/index.png',
  location: '/assets/image/chart/location.png',
  logo: '/assets/image/chart/logo.png',
  logo2: '/assets/image/chart/logo2.png',
  logo3: '/assets/image/chart/logo3.png',
  mypage: '/assets/image/chart/mypage.svg',
  rain: '/assets/image/chart/rain.png',
  riskGraph: '/assets/image/chart/risk-graph.png',
  riskTotal: '/assets/image/chart/risk-total.png',
  temp: '/assets/image/chart/temp.png',
  weeklyGold: '/assets/image/chart/weekly-gold.png',
  weeklySilver: '/assets/image/chart/weekly-silver.png',
  weekly: '/assets/image/chart/weekly.png',
  wind: '/assets/image/chart/wind.png'
};

/**
 * 깃발 이미지
 * @type {{red: *, orange: *, green: *, yellow: *}}
 */
export const flagsIcon = {
  red: '/assets/image/environment/flag-red.png',
  orange: '/assets/image/environment/flag-orange.png',
  yellow: '/assets/image/environment/flag-yellow.png',
  green: '/assets/image/environment/flag-green.png'
};

/**
 * 환경 작은 아이콘
 * @type {{rain, common, temperature, humidity, barometer, wind}}
 */
export const environmentMiniIcon = {
  common: '/assets/icon/environment/icon-pm.svg',
  humidity: '/assets/icon/environment/icon-humidity.svg',
  barometer: '/assets/icon/environment/icon-barometer.svg',
  rain: '/assets/icon/environment/icon-rain.svg',
  temperature: '/assets/icon/environment/icon-temperature.svg',
  wind: '/assets/icon/environment/icon-wind.svg'
};

export const weatherImage = {
  manyCloud: '/assets/image/environment/weather_many_cloud.svg'
};

/**
 * PPE 보호장비 이미지
 */
export const ppeImages = {
  ppe: '/assets/image/ppe/image-ppe.png'
};

export const weatherIcons = {
  '01d': '/assets/icon/weather/01d.svg',
  '02d': '/assets/icon/weather/02d.svg',
  '03d': '/assets/icon/weather/03d.svg',
  '04d': '/assets/icon/weather/04d.svg',
  '09d': '/assets/icon/weather/09d.svg',
  '10d': '/assets/icon/weather/10d.svg',
  '11d': '/assets/icon/weather/11d.svg',
  '13d': '/assets/icon/weather/13d.svg',
  '50d': '/assets/icon/weather/50d.svg',
  '01n': '/assets/icon/weather/01d.svg',
  '02n': '/assets/icon/weather/02d.svg',
  '03n': '/assets/icon/weather/03d.svg',
  '04n': '/assets/icon/weather/04d.svg',
  '09n': '/assets/icon/weather/09d.svg',
  '10n': '/assets/icon/weather/10d.svg',
  '11n': '/assets/icon/weather/11d.svg',
  '13n': '/assets/icon/weather/13d.svg',
  '50n': '/assets/icon/weather/50d.svg'
};

export const findWeatherIcon = (iconName) => {
  const iconTitle = iconName.replaceAll('n', 'd'.replaceAll('.png', '').replaceAll(' ', ''));
  return weatherIcons[iconTitle];
};

/** Clock Image */
export const clockImages = {
  clock: '/assets/image/clock/image-clock-bg.png',
  hour: '/assets/image/clock/image-clock-hour.svg',
  minute: '/assets/image/clock/image-clock-minute.svg',
  second: '/assets/image/clock/image-clock-second.svg'
};

/** Samsung Dashboard */
export const samsungMapImages = {
  marker_green: '/assets/icon/samsung-dashboard/marker-green.svg',
  marker_red: '/assets/icon/samsung-dashboard/marker-red.svg'
};

export const clusterImages = {
  cluster_gray: '/assets/icon/cluster/cluster-gray.svg',
  cluster_green: '/assets/icon/cluster/cluster-green.svg',
  cluster_orange: '/assets/icon/cluster/cluster-orange.svg',
  cluster_yellow: '/assets/icon/cluster/cluster-yellow.svg',
  cluster_blue: '/assets/icon/cluster/cluster-blue.svg',
  cluster_red: '/assets/icon/cluster/cluster-red.svg'
};

/** GS Dashboard */
export const gsDashboardImages = {
  hook_none: '/assets/icon/gs-dashboard/hook-none.svg',
  hook_normal: '/assets/icon/gs-dashboard/hook-normal.svg',
  hook_warning: '/assets/icon/gs-dashboard/hook-warn.svg',
  hook_danger: '/assets/icon/gs-dashboard/hook-danger.svg',

  //
  helmet_none: '/assets/icon/gs-dashboard/helmet-none.svg',
  helmet_normal: '/assets/icon/gs-dashboard/helmet-normal.svg',
  helmet_warning: '/assets/icon/gs-dashboard/helmet-warn.svg',
  helmet_warning_blue: '/assets/icon/gs-dashboard/helmet-warn-blue.svg',
  helmet_danger: '/assets/icon/gs-dashboard/helmet-danger.svg',

  //
  cctv_none: '/assets/icon/gs-dashboard/cctv-none.svg',
  cctv_normal: '/assets/icon/gs-dashboard/cctv-normal.svg',
  cctv_warning: '/assets/icon/gs-dashboard/cctv-warn.svg',
  cctv_danger: '/assets/icon/gs-dashboard/cctv-danger.svg',

  //
  person_none: '/assets/icon/gs-dashboard/person-none.svg',
  person_normal: '/assets/icon/gs-dashboard/person-normal.svg',
  person_warning: '/assets/icon/gs-dashboard/person-warn.svg',
  person_warning_blue: '/assets/icon/gs-dashboard/person-warn-blue.svg',
  person_danger: '/assets/icon/gs-dashboard/person-danger.svg',

  //
  watch_none: '/assets/icon/gs-dashboard/watch-none.svg',
  watch_normal: '/assets/icon/gs-dashboard/watch-normal.svg',
  watch_warning: '/assets/icon/gs-dashboard/watch-warn.svg',
  watch_warning_blue: '/assets/icon/gs-dashboard/watch-warn-blue.svg',
  watch_danger: '/assets/icon/gs-dashboard/watch-danger.svg',

  //
  gas_none: '/assets/icon/gs-dashboard/gas-none.svg',
  gas_normal: '/assets/icon/gs-dashboard/gas-normal.svg',
  gas_warning: '/assets/icon/gs-dashboard/gas-warn.svg',
  gas_danger: '/assets/icon/gs-dashboard/gas-danger.svg'
};

/** GS Dashboard */
export const gsInfoboxImages = {
  heart: '/assets/icon/gs-infobox/heart.svg',
  oxygen: '/assets/icon/gs-infobox/oxygen.svg',
  pressure: '/assets/icon/gs-infobox/pressure.svg',
  temperature: '/assets/icon/gs-infobox/temperature.svg'
};

/** Smart Device Icons */
export const smartDeviceIcons = {
  helmet: '/assets/icon/smart-device/device/helmet.svg',
  watch: '/assets/icon/smart-device/device/watch.svg',
  hook: '/assets/icon/smart-device/device/hook.svg',

  // battery
  battery0: '/assets/icon/smart-device/battery/0.svg',
  battery20: '/assets/icon/smart-device/battery/20.svg',
  battery40: '/assets/icon/smart-device/battery/40.svg',
  battery60: '/assets/icon/smart-device/battery/60.svg',
  battery80: '/assets/icon/smart-device/battery/80.svg',
  battery100: '/assets/icon/smart-device/battery/100.svg',

  // avl
  avl_icon: '/assets/icon/smart-device/avl/avl_icon.svg',
  avl_layer: '/assets/icon/smart-device/avl/avl_layer.svg',
  avl_on: '/assets/icon/smart-device/avl/avl_marker_on.svg',
  avl_off: '/assets/icon/smart-device/avl/avl_marker_off.svg',

  // gas
  gas_icon: '/assets/icon/smart-device/gas/gas.svg',
  gas_white: '/assets/icon/smart-device/gas/white.svg'
};

/** Tbm Icons */
export const tbmIcons = {
  person_total: '/assets/icon/tbm/person_total.svg',
  person_in: '/assets/icon/tbm/person_in.svg',
  person_out: '/assets/icon/tbm/person_out.svg',
  person_complete: '/assets/icon/tbm/person_complete.svg'
};
